import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqs } from '../data/mock';

const FAQ = () => {
  return (
    <section id="faq" className="py-24 bg-slate-950 relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 grid-background opacity-20"></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Frequently Asked <span className="text-cyan-400 neon-text">Questions</span>
            </h2>
            <p className="text-xl text-gray-400">
              Everything you need to know about EFAM
            </p>
          </div>

          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq) => (
              <AccordionItem
                key={faq.id}
                value={`item-${faq.id}`}
                className="glass-card rounded-xl px-6 border-none"
              >
                <AccordionTrigger className="text-left text-lg font-semibold text-white hover:text-cyan-400 transition-colors py-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-400 pb-6 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          {/* Payment & Shipping Info */}
          <div className="mt-12 glass-card p-8 rounded-xl border border-cyan-500/30">
            <h3 className="text-2xl font-bold text-white mb-6 text-center">
              Payment & <span className="text-cyan-400">Shipping</span>
            </h3>
            
            <div className="grid md:grid-cols-2 gap-8">
              {/* Shipping Options */}
              <div className="space-y-4">
                <h4 className="text-lg font-semibold text-cyan-400 mb-3">Shipping</h4>

                <div className="p-4 bg-slate-900/50 rounded-lg">
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-white font-semibold">Express Worldwide</span>
                    <span className="text-cyan-400 font-bold">Included</span>
                  </div>
                  <p className="text-gray-400 text-sm">2-4 weeks priority air freight</p>
                  <p className="text-gray-500 text-xs mt-1">EFAM is premium — so is our shipping. Every unit ships Express, no extra fee.</p>
                </div>
              </div>
              
              {/* Payment & Delivery */}
              <div className="space-y-4">
                <h4 className="text-lg font-semibold text-cyan-400 mb-3">Payment & Delivery</h4>
                
                <div className="space-y-3 text-gray-300">
                  <div className="flex items-start space-x-3">
                    <span className="text-cyan-400 mt-1">✓</span>
                    <span>Secure payment via Stripe</span>
                  </div>
                  <div className="flex items-start space-x-3">
                    <span className="text-cyan-400 mt-1">✓</span>
                    <span>All prices shown in AUD; GST applies where required</span>
                  </div>
                  <div className="flex items-start space-x-3">
                    <span className="text-cyan-400 mt-1">✓</span>
                    <span>Express delivery is included in the displayed price</span>
                  </div>
                  <div className="flex items-start space-x-3">
                    <span className="text-cyan-400 mt-1">✓</span>
                    <span>International customs duties or local taxes may apply</span>
                  </div>
                </div>
              </div>
            </div>
            
            {/* CTA */}
            <div className="mt-8 text-center">
              <button
                onClick={() => {
                  const element = document.querySelector('#packages');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
                className="bg-cyan-500 hover:bg-cyan-400 text-black font-bold px-8 py-3 rounded-full transition-colors"
              >
                View Products & Purchase
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
